import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { TargetNodeTreeEditorSearchSchema } from '@/features/stacktrace/products/components/TargetNodeTreeEditor/search-schema';

// 顧客詳細 > 利用機能の編集画面。
// URL search（expandMode: 展開モードタブ / q: 名前検索）は共通エディタの
// スキーマ（TargetNodeTreeEditorSearchSchema）を利用し、コンポーネントは
// index.lazy.tsx で遅延ロードする。
// 利用機能タブ自体は target-nodes/index に居るため、完了時はそこへ戻す。
export const Route = createFileRoute('/_stacktrace/customers/$customerId/_layout/target-nodes/edit/')({
  validateSearch: zodValidator(TargetNodeTreeEditorSearchSchema)
});